import { render } from "./EvalvationDepartmentDetail.vue?vue&type=template&id=3c4b4222"
import script from "./EvalvationDepartmentDetail.vue?vue&type=script&lang=js"
export * from "./EvalvationDepartmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__